import { render, staticRenderFns } from "./PolicyGeneral.vue?vue&type=template&id=12bc98dc&scoped=true&"
import script from "./PolicyGeneral.vue?vue&type=script&lang=js&"
export * from "./PolicyGeneral.vue?vue&type=script&lang=js&"
import style0 from "./PolicyGeneral.vue?vue&type=style&index=0&id=12bc98dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bc98dc",
  null
  
)

component.options.__file = "PolicyGeneral.vue"
export default component.exports